import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import AdminNavBar from './AdminNavBar';

const pastelColors = [
  '#ccb4d6', '#f8e1f4', '#b4e7f8', '#f8e7b4', '#e1f8d6', '#f8b4c4'
];

const AdminRedeemCodes = () => {
  const [codes, setCodes] = useState([]);
  const [newCode, setNewCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);

  const fetchCodes = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://api.laviopaperie.com/api/redeem-codes');
      const data = await res.json();
      if (data.success) {
        // Urutkan data terbaru di atas berdasarkan created_at jika ada
        const sortedCodes = [...data.codes].sort((a, b) => {
          if (a.created_at && b.created_at) {
            return new Date(b.created_at) - new Date(a.created_at);
          }
          // fallback ke id jika tidak ada created_at
          if (a.id && b.id) return b.id - a.id;
          return 0;
        });
        setCodes(sortedCodes);
      }
    } catch {}
    setLoading(false);
  };

  useEffect(() => { fetchCodes(); }, []);

  const handleCreate = async () => {
    setCreating(true);
    try {
      const res = await fetch('https://api.laviopaperie.com/api/redeem-codes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}'
      });
      const data = await res.json();
      if (data.success) {
        fetchCodes();
        Swal.fire({ icon: 'success', title: 'Kode berhasil dibuat', text: `Kode: ${data.code}`, confirmButtonColor: pastelColors[0] });
      } else {
        Swal.fire({ icon: 'error', title: data.message || 'Gagal', confirmButtonColor: pastelColors[0] });
      }
    } catch {
      Swal.fire({ icon: 'error', title: 'Server error', confirmButtonColor: pastelColors[0] });
    }
    setCreating(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      width: '100vw',
      background: `linear-gradient(120deg, ${pastelColors.join(', ')})`,
      backgroundSize: '300% 300%',
      animation: 'pastelBg 18s ease-in-out infinite',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '40px 0',
    }}>
      <AdminNavBar active="/admin/redeem-codes" />
      <h2 style={{ fontFamily: 'Quicksand, sans-serif', color: '#7c5fa6', fontWeight: 700, fontSize: 32, marginBottom: 24 }}>Admin Redeem Codes</h2>
      <button
        onClick={handleCreate}
        disabled={creating}
        style={{
          padding: '12px 32px',
          borderRadius: 999,
          border: 'none',
          background: creating ? pastelColors[1] : 'linear-gradient(90deg, #a28ad6 0%, #f8e1f4 100%)',
          color: '#fff',
          fontSize: 20,
          fontWeight: 700,
          letterSpacing: 2,
          boxShadow: '0 4px 16px 0 rgba(204,180,214,0.18)',
          cursor: creating ? 'not-allowed' : 'pointer',
          marginBottom: 32,
          transition: 'all 0.2s',
        }}
      >{creating ? 'Membuat...' : 'Buat Kode'}</button>
      <div style={{ width: '95vw', maxWidth: 700, background: 'rgba(255,255,255,0.92)', borderRadius: 16, boxShadow: '0 4px 24px 0 rgba(204,180,214,0.12)', padding: 24 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'Quicksand, sans-serif', fontSize: 16 }}>
          <thead>
            <tr style={{ background: '#f8e1f4' }}>
              <th style={{ padding: 10, borderRadius: 8 }}>Code</th>
              <th style={{ padding: 10, borderRadius: 8 }}>Status</th>
              <th style={{ padding: 10, borderRadius: 8 }}>Created at</th>
              <th style={{ padding: 10, borderRadius: 8 }}>Updated at</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 24 }}>Loading...</td></tr>
            ) : codes.length === 0 ? (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 24 }}>No code yet</td></tr>
            ) : codes.map(code => (
              <tr key={code.id} style={{ background: code.is_used ? '#e1f8d6' : '#fff' }}>
                <td style={{ padding: 10, textAlign: 'center', fontWeight: 700, letterSpacing: 2 }}>{code.code}</td>
                <td style={{ padding: 10, textAlign: 'center', color: code.is_used ? '#4caf50' : '#a28ad6', fontWeight: 700 }}>{code.is_used ? 'Used' : 'Unused'}</td>
                <td style={{ padding: 10, textAlign: 'center' }}>{code.created_at ? new Date(code.created_at).toLocaleString() : '-'}</td>
                <td style={{ padding: 10, textAlign: 'center' }}>{code.used_at ? new Date(code.used_at).toLocaleString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminRedeemCodes;
